module.exports = __webpack_public_path__ + "img/tap.da57d552.svg";